import api from './api';
import { AppResponse } from "../models/common/app-response";
import { TerminalShortInfoDto } from '../models/terminals/terminalShortInfoDto';
import { PaginatedResponse } from '../models/common/paginated-response';
import { TerminalFilter } from '../models/terminals/terminalFilter';
import { EditTerminalDto } from '../models/terminals/editTerminalDto';
import { TerminalDetailsDto } from '../models/terminals/terminalDetailsDto';
import { AddTerminalDto } from '../models/terminals/addTerminalDto';
import { SearchTerminalFilter } from '../models/terminals/searchTerminalFilter';
import { SearchTerminalDto } from '../models/terminals/searchTerminalDto';
import { TerminalTypeDto } from '../models/terminals/terminalTypeDto';
import { TerminalUseTypeDto } from '../models/terminals/terminalUseTypeDto';

class TerminalsService {

    baseUrl: string = "/api/v1/terminals";

    getByFilter = (filter?: TerminalFilter) => {
        return api.post<AppResponse<PaginatedResponse<TerminalShortInfoDto>>>(`${this.baseUrl}/filter`, filter);
    }

    search = (filter?: SearchTerminalFilter) => {
        return api.get<AppResponse<PaginatedResponse<SearchTerminalDto>>>(`${this.baseUrl}/search`, { params: filter });
    }

    getById = (id: number) => {
        return api.get<AppResponse<TerminalDetailsDto>>(`${this.baseUrl}/${id}`);
    }

    getByCompanyId = (companyId: number) => {
        return api.get<AppResponse<TerminalShortInfoDto[]>>(`${this.baseUrl}/${companyId}/terminals`);
    }

    add = (data: AddTerminalDto) => {
        return api.post<AppResponse<number>>(this.baseUrl, data);
    }

    edit = (data: EditTerminalDto) => {
        return api.put<AppResponse<number>>(`${this.baseUrl}/${data.id}`, data);
    }

    linkToCompany = (terminalId: number, companyId: number) => {
        return api.post<AppResponse<number>>(`${this.baseUrl}/${terminalId}/company/${companyId}`);
    }

    updateIntegrityCheck = (terminalId: number, isEnabled: boolean) => {
        return api.post<AppResponse<void>>(`${this.baseUrl}/${terminalId}/test-mode`, { performSwIntegrityCheck: isEnabled });
    }

    resetCaseIntegrityCheck = (terminalId: number) => {
        return api.put<AppResponse<void>>(`${this.baseUrl}/${terminalId}/reset-case-integrity-check`);
    }

    /**
     * Установить значение тогла терминала "Разрешены повторные осмотры".
     *
     * @param terminalId - Идентификатор терминала
     * @param verifyRepeatCheckups - Новое значение признака повторных осмотров
     * @returns Промис, содержащий количество изменённых сущностей
     */
    updateVerifyRepeatCheckups = (terminalId: number, verifyRepeatCheckups: boolean) => {
        return api.patch<AppResponse<void>>(`${this.baseUrl}/${terminalId}/verify-repeat-checkups`, { verifyRepeatCheckups: verifyRepeatCheckups });
    }

    /**
     * Fetch terminal types for ERP/НИИАТ
     */
    getTerminalTypes = () => {
        return api.get<AppResponse<TerminalTypeDto[]>>(`${this.baseUrl}/types`);
    }

    /**
     * Fetch terminal use types for ERP/НИИАТ
     */
    getTerminalUseTypes = () => {
        return api.get<AppResponse<TerminalUseTypeDto[]>>(`${this.baseUrl}/use-types`);
    }

    /**
     * Переключить интеграцию с НИИАТ для терминала
     */
    toggleNiiatIntegration = (terminalId: number, isEnabled: boolean) => {
        return api.patch<AppResponse<boolean>>(`${this.baseUrl}/${terminalId}/niiat-integration`, { isEnabled });
    }
}

export const terminalsService = new TerminalsService();